import React from 'react';
import { SectionHeader } from '../components/UI';
import { useInView } from '../hooks/useInView';
import { TOOLS } from '../data/courseData';
import styles from './Tools.module.css';

export default function Tools() {
  const [ref, inView] = useInView();

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <SectionHeader
          label="Tools You'll Master"
          title="Industry-standard platforms, hands-on from day one"
          subtitle="Graduate knowing your way around the exact tools employers and clients expect you to use."
          center
        />
        <div className={styles.grid} ref={ref}>
          {TOOLS.map((tool, i) => (
            <div
              key={i}
              className={`${styles.chip} ${inView ? styles.visible : ''}`}
              style={{ transitionDelay: `${i * 0.06}s` }}
            >
              <span className={styles.dot} />
              {tool}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
